import { FenixA321MarketingSeo } from "../../../content/templateMarketing/fenix-a320-seo";
import { AircraftAddonTemplate } from "../../../lib/model/addonTemplate";
import fenixA321Image from "../../images/templates/fenix-a321.jpg";

import { fenixA320Template } from "./fenix-a320";

export const fenixA321Template: AircraftAddonTemplate = {
  ...fenixA320Template,
  title: "Fenix A321",
  id: "fenix-a321",
  image: fenixA321Image,
  infoMarketingBlurb: FenixA321MarketingSeo,
};
